import Form, {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  SimpleItem,
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import React, { useCallback, useRef } from 'react';
import { putApi } from '../../../../apiUtils';
import { useTranslation } from '../../../../contexts/translation';
import { API_URL } from '../../../../utils/apiUrl';
import './styles.scss';

interface Props {
  taskId: number;
  commentId: number;
  visible: boolean;
  defaultComment: string;
  onSuccess: (comment: any) => void;
  onCancel: () => void;
}

export const TaskServiceCommentsUpdateForm = ({
  taskId,
  commentId,
  visible,
  defaultComment,
  onSuccess,
  onCancel,
}: Props) => {
  const { translate } = useTranslation();
  const transFormName = 'Task.ServiceDeskComment';

  const formRef = useRef<any>();
  const formData = useRef<any>({ comment: defaultComment });

  const onSubmit = useCallback(async () => {
    await putApi({
      url: API_URL.TASK_COMMENT_UPDATE,
      data: { ...formData.current, id: commentId, taskId },
      callAfterSuccess: async (data) => {
        onSuccess(data);
        notify(translate!('Comment updated', transFormName), 'success');
      },
    });
  }, []);

  return (
    <div
      className={`task-service-comment-form-container${!visible ? ' hidden' : ''}`}
      style={{ padding: '0 5px 0 5px' }}
    >
      <form>
        <Form formData={formData.current} ref={formRef} colCount={3}>
          <SimpleItem
            dataField="comment"
            editorType="dxHtmlEditor"
            colSpan={3}
            editorOptions={{
              height: 250,
              resizable: {
                handles: 's', // pouze vertikální resize (spodní hrana)
              },
              toolbar: {
                items: [
                  'undo',
                  'redo',
                  'bold',
                  'italic',
                  'underline',
                  'strike',
                  'alignLeft',
                  'alignCenter',
                  'alignRight',
                  'alignJustify',
                  'orderedList',
                  'bulletList',
                  'fontSize',
                  'fontColor',
                  'color',
                  'background',
                  'link',
                  'clear',
                ],
              },
              mediaResizing: {
                enabled: true,
              },
            }}
          >
            <Label location={'top'} text={translate!('Update comment', transFormName)} />
          </SimpleItem>
          <GroupItem colCount={7} colSpan={3}>
            <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
              <ButtonOptions
                width={'100%'}
                text={translate!('Cancel edit', transFormName)}
                type={'primary'}
                useSubmitBehavior={false}
                onClick={() => onCancel()}
              />
            </ButtonItem>
            <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
              <ButtonOptions
                width={'100%'}
                text={translate!('Save', transFormName)}
                type={'success'}
                useSubmitBehavior={false}
                onClick={() => onSubmit()}
              />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );
};
